module.exports = __webpack_public_path__ + "static/img/partner-zwds.0a2b435.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-zwds.png
// module id = zJAv
// module chunks = 34